import { render } from "./InventoryProcessView.vue?vue&type=template&id=08530f40&scoped=true"
import script from "./InventoryProcessView.vue?vue&type=script&lang=js"
export * from "./InventoryProcessView.vue?vue&type=script&lang=js"

import "./InventoryProcessView.vue?vue&type=style&index=0&id=08530f40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08530f40"]])

export default __exports__